<template>
<v-card height="100%" dark color="darkBackground">
    <v-card-title style="background: white">
        <span style="color: black"> {{title}}  </span>
    </v-card-title>
    <v-divider class="mx-4"></v-divider>
    <v-card-text>
        <slot></slot>
    </v-card-text>
</v-card>
</template>


<script>
export default {
    name: 'ScrollableVueCard',
    props:{
        title: String,
        chip: String
    },
    data: () => ({
    })
}
</script>
<style scoped> 

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  padding: 0;
}
</style>